<template>
  <div class="cont">
    <div class="title" :class="title_object">
      {{   curData.name }}
    </div>
    <div class="clear"  v-if=" id == 'EC型'  ">
      <div style="width: 311px  ;float:left" >
        <el-image
          style="width: 311px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ; position:relative" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 91px ; position:absolute;right:0;top:-45px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 411px  ;float:left ; margin-top:27px" >
        <el-image
          style="width: 411px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 355px  ;float:right ; margin-top:26px ; text-align:right" >
        <el-image
          style="width: 255px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style="width: 500px  ;float:left ; margin-top:38px" >
        <el-image
          style="width: 472px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 254px  ;float:right ; margin-top:9px ; text-align:right" >
        <el-image
          style="width: 254px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:46px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:0px ; text-align:center" >
        <el-image
          style="width: 733px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top: 28px ; " >
        <el-image
          style="width: 607px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top: 65px ; " >
        <el-image
          style="width: 781px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top: 17px ; " >
        <el-image
          style="width: 314px ; "
          v-show="curData.src13 "
          :src=" curData.src13  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'ES型'  ">
      <div style="width: 286px  ;float:left" >
        <el-image
          style="width: 286px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ; position:relative" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 91px ; position:absolute;right:0;top:-45px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 414px  ;float:left ; margin-top:43px" >
        <el-image
          style="width: 414px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 522px  ;float:left ; margin-top:47px" >
        <el-image
          style="width: 522px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top:44px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 754px  ;float:left ; margin-top:10px" >
        <el-image
          style="width: 754px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 603px  ;float:left ; margin-top:28px" >
        <el-image
          style="width: 603px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 772px  ;float:left ; margin-top:69px" >
        <el-image
          style="width: 772px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 342px  ;float:left ; margin-top:17px" >
        <el-image
          style="width: 342px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'M型'  ">
      <div style="width: 311px  ;float:left" >
        <el-image
          style="width: 311px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ; position:relative" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 91px ; position:absolute;right:0;top:-45px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 411px  ;float:left ; margin-top:57px" >
        <el-image
          style="width: 411px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 627px  ;float:left ; margin-top:38px" >
        <el-image
          style="width: 627px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top:46px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 752px  ;float:left ; margin-top:10px" >
        <el-image
          style="width: 752px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 607px  ;float:left ; margin-top:30px" >
        <el-image
          style="width: 607px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 777px  ;float:left ; margin-top:69px" >
        <el-image
          style="width: 777px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 314px  ;float:left ; margin-top:18px" >
        <el-image
          style="width: 314px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 778px  ;float:left ; margin-top:49px" >
        <el-image
          style="width: 778px ; "
          v-show="curData.src13 "
          :src=" curData.src13  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 243px  ;float:left ; margin-top:39px" >
        <el-image
          style="width: 243px ; "
          v-show="curData.src14 "
          :src=" curData.src14  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 765px  ;float:left ; margin-top:22px" >
        <el-image
          style="width: 765px ; "
          v-show="curData.src15 "
          :src=" curData.src15  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'Premium型'  ">
      <div style="width: 247px  ;float:left" >
        <el-image
          style="width: 247px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ; position:relative" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 91px ; position:absolute;right:0;top:-45px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 413px  ;float:left ; margin-top:57px" >
        <el-image
          style="width: 413px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 505px  ;float:left ; margin-top:38px" >
        <el-image
          style="width: 505px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top:46px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 736px  ;float:left ; margin-top:10px" >
        <el-image
          style="width: 736px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 607px  ;float:left ; margin-top:29px" >
        <el-image
          style="width: 607px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 777px  ;float:left ; margin-top:69px" >
        <el-image
          style="width: 777px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 342px  ;float:left ; margin-top:18px" >
        <el-image
          style="width: 342px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top:55px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top:13px" >
        <div style="width:161px;float:left;margin-right:38px;">
          <el-image
            style="width: 161px ; "
            v-show="curData.src13 "
            :src=" curData.src13  "
            fit="contain"
          >
          </el-image>
          <el-image
            style="width: 138px ; margin-top:5px"
            v-show="curData.src14 "
            :src=" curData.src14  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width:161px;float:left;margin-right:38px;">
          <el-image
            style="width: 161px ; "
            v-show="curData.src15 "
            :src=" curData.src15  "
            fit="contain"
          >
          </el-image>
          <el-image
            style="width: 133px ; margin-top:5px"
            v-show="curData.src16 "
            :src=" curData.src16  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width:161px;float:left;margin-right:38px;">
          <el-image
            style="width: 161px ; "
            v-show="curData.src17 "
            :src=" curData.src17  "
            fit="contain"
          >
          </el-image>
          <el-image
            style="width: 126px ; margin-top:5px"
            v-show="curData.src18 "
            :src=" curData.src18  "
            fit="contain"
          >
          </el-image>
        </div>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'R01型' || id == 'RA型' || id == 'RD型' || id == 'RE型' || id == 'RGM型' || id == 'RGS型' || id == 'RN型' ">
      <div style="width: 100% ; height:418px ;margin-bottom:53px"  >
        <el-image
          style="width: 340px ; float:left "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 302px ;float:right "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 339px ; float:right;margin-top:35px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style="width: 100% ; height:429px; margin-bottom:35px "  id='RA4'>
        <el-image

          style="width: 340px ; float:left;"
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 335px ; float:right;"
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style='width:100%;height:39px;margin-bottom:59px'>
        <el-image
          style="width: 716px ; float:left "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style='width:100%;height:487px;margin-bottom:66px' id='RN7'>
        <el-image
          style="width: 777px ; float:left;"
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style='width:100%;height:485px;margin-bottom:61px' id='RGS8'>
        <el-image
          style="width: 778px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style='width:100%;height:486px;margin-bottom:61px;' id='RD9'>
        <el-image
          style="width: 778px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style='width:100%;height:857px;' id='RGM10'>
        <el-image
          style="width: 778px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'RGX型' || id == 'X型' ">
      <div style="width: 309px  ;float:left" >
        <el-image
          style="width: 309px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 413px  ;float:left ; margin-top:38px" >
        <el-image
          style="width: 413px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:15px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:15px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src5 "
          :src=" curData.src5 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 472px  ;float:left ; margin-top: 38px" >
        <el-image
          style="width: 472px ; "
          v-show="curData.src6 "
          :src=" curData.src6 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ; margin-top: 71px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src7 "
          :src=" curData.src7 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 606px  ;float:left ; margin-top: 10px" >
        <el-image
          style="width: 606px ; "
          v-show="curData.src8 "
          :src=" curData.src8 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 292px  ;float:right ; " >
        <el-image
          style="width: 242px ; "
          v-show="curData.src9 "
          :src=" curData.src9 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 774px  ;float:left ;margin-top:44px " >
        <el-image
          style="width: 774px ; "
          v-show="curData.src10 "
          :src=" curData.src10 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;margin-top:18px " >
        <el-image
          style="width: 314px ; "
          v-show="curData.src11 "
          :src=" curData.src11 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 296px  ;float:left ;margin-top:69px " >
        <el-image
          style="width: 296px ; "
          v-show="curData.src12 "
          :src=" curData.src12 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ;margin-top:69px " >
        <el-image
          style="width: 330px ; "
          v-show="curData.src13 "
          :src=" curData.src13 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 413px  ;float:left ;margin-top:42px " >
        <el-image
          style="width: 413px ; "
          v-show="curData.src14 "
          :src=" curData.src14 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;margin-top:15px ">
        <div style="width: 139px  ;float:right ; margin-top:15px" >
          <el-image
            style="width: 139px ; "
            v-show="curData.src4 "
            :src=" curData.src4  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 139px  ;float:right ; margin-top:15px" >
          <el-image
            style="width: 139px ; "
            v-show="curData.src5 "
            :src=" curData.src5 "
            fit="contain"
          >
          </el-image>
        </div>
      </div>
      <div style="width: 774px  ;float:left ;margin-top:33px " >
        <el-image
          style="width: 774px ; "
          v-show="curData.src15 "
          :src=" curData.src15 "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 314px  ;float:left ;margin-top:22px " >
        <el-image
          style="width: 314px ; "
          v-show="curData.src16 "
          :src=" curData.src16 "
          fit="contain"
        >
        </el-image>
      </div>

    </div>
    <div class="clear"  v-else-if=" id == 'Specom_GT' || id == 'Specom_K' || id == 'Specom_α' || id == 'Specom_β' ">
      <div style='height:1800px;' class="clear" id='Specom_cont'>
        <div style="width: 340px  ;float:left ; margin-top:22px" >
          <el-image
            style="width: 340px ; "
            v-show="curData.src1 "
            :src=" curData.src1  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 377px  ;float:right ; " >
          <el-image
            style="width: 377px ; "
            v-show="curData.src2 "
            :src=" curData.src2  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 299px  ;float:right ; margin-top:21px " >
          <el-image
            style="width: 299px ; "
            v-show="curData.src3 "
            :src=" curData.src3  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 340px  ;float:left ; margin-top:63px " >
          <el-image
            style="width: 340px ; "
            v-show="curData.src4 "
            :src=" curData.src4  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 335px  ;float:right ; margin-top:101px " >
          <el-image
            style="width: 335px ; "
            v-show="curData.src5 "
            :src=" curData.src5  "
            fit="contain"
          >
          </el-image>
        </div>
        <div style="width: 340px  ;float:left ; margin-top:61px " >
          <el-image
            style="width: 340px ; "
            v-show="curData.src6 "
            :src=" curData.src6  "
            fit="contain"
          >
          </el-image>
        </div>
      </div>

      <div style="width: 773px  ;float:left ; margin-top:61px " >
        <el-image
          style="width: 773px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 777px  ;float:left ; margin-top:38px " >
        <el-image
          style="width: 777px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 775px  ;float:left ; margin-top:38px " >
        <el-image
          style="width: 775px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'Z型'  ">
      <div style="width: 246px  ;float:left" >
        <el-image
          style="width: 246px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 380px  ;float:right ; position:relative;text-align:right" >
        <el-image
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image
          style="width: 91px ; position:absolute;right:0;top:-45px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 353px  ;float:left;margin-top:43px" >
        <el-image
          style="width: 353px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 139px  ;float:right ; margin-top:16px" >
        <el-image
          style="width: 139px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 700px  ;float:left;margin-top:58px" >
        <el-image
          style="width: 472px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left;margin-top:88px" >
        <el-image
          style="width: 95px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 687px  ;float:left;margin-top:10px" >
        <el-image
          style="width: 687px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:right;margin-top:0;text-align:right" >
        <el-image
          style="width: 202px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 607px  ;float:left;margin-top:45px;" >
        <el-image
          style="width: 607px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 771px  ;float:left;margin-top:69px;" >
        <el-image
          style="width: 771px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 342px  ;float:left;margin-top:19px;" >
        <el-image
          style="width: 342px ; "
          v-show="curData.src13 "
          :src=" curData.src13  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear"  v-else-if=" id == 'S型'  ">
      <div style="width: 308px  ;float:left;margin-left: 46px;" >
        <el-image
                style="width: 308px ; "
                v-show="curData.src1 "
                :src=" curData.src1  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 351px  ;float:left ; position:relative;margin-left:128px;" >
        <el-image
                style="width: 351px ; "
                v-show="curData.src2 "
                :src=" curData.src2  "
                fit="contain"
        >
        </el-image>

      </div>
      <div style="width:100%;float:left;margin-top:24px;margin-left: 46px;" >
        <el-image
                style="width: 775px ; "
                v-show="curData.src3 "
                :src=" curData.src3  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width:100%;float:left ; margin-top:48px;margin-left: 46px;" >
        <el-image
                style="width: 285px; "
                v-show="curData.src4 "
                :src=" curData.src4  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;float:left ; margin-top:40px;margin-left: 46px;" >
        <el-image
                style="width: 720px ; "
                v-show="curData.src5 "
                :src=" curData.src5  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width:100%;float:left;margin-top:18px;margin-left: 46px;" >
        <el-image
                style="width: 342px ; "
                v-show="curData.src6 "
                :src=" curData.src6  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width:100%;float:left;margin-top:39px;margin-left: 46px;" >
        <el-image
                style="width: 427px ; "
                v-show="curData.src7 "
                :src=" curData.src7"
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width:100%;float:left;margin-top:30px;margin-left: 46px;" >
        <el-image
                style="width: 95px ; "
                v-show="curData.src8"
                :src=" curData.src8"
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 761px;float:left;margin-top:10px;;margin-left: 46px;" >
        <el-image
                style="width:761px ; "
                v-show="curData.src11 "
                :src=" curData.src11  "
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 606px;float:left;margin-top:47px;;margin-left: 46px;" >
        <el-image
                style="width:606px ; "
                v-show="curData.src9 "
                :src=" curData.src9"
                fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 755px;float:left;margin-top:32px;;margin-left: 46px;" >
        <el-image
                style="width:755px; "
                v-show="curData.src10 "
                :src=" curData.src10"
                fit="contain"
        >
        </el-image>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      id : '' ,
      pageData : {
        EC型 : {
          name : 'EC型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/EC型/img13.png') ,
        } ,
        ES型 : {
          name : 'ES型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/ES型/img12.png') ,
        } ,
        M型 : {
          name : 'M型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakePadsDetail/M型/img15.png') ,

        } ,
        Premium型 : {
          name : 'P型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img15.png') ,
          src16 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img16.png') ,
          src17 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img17.png') ,
          src18 :  require('@/assets/image/variousproducts/brakePadsDetail/Premium型/img18.png') ,
        } ,
        R01型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        RA型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        RD型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        RE型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        RGM型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        RGS型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        } ,
        RGX型 : {
          name : 'X/RGX型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img15.png') ,
          src16 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img16.png') ,
        },
        RN型 : {
          name : 'R系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RN型/img10.png') ,
        },
        Specom_GT : {
          name : 'SPECOM系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png') ,
        },
        Specom_K : {
          name : 'SPECOM系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png') ,
        },
        Specom_α : {
          name : 'SPECOM系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png') ,
        },
        Specom_β : {
          name : 'SPECOM系列' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Specom型/img9.png') ,
        },
        X型 : {
          name : 'X/RGX型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img15.png') ,
          src16 :  require('@/assets/image/variousproducts/brakePadsDetail/RGX型/img16.png') ,

        } ,
        Z型 : {
          name : 'Z型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakePadsDetail/Z型/img13.png') ,
        },
        S型 : {
          name : 'S型' ,
          src1 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakePadsDetail/S型/11.png') ,
        }


      } ,
      curData : {}
    };
  },
  computed: {
    title_object: function () {
      return {
        "t_Premium" : this.curData.name == 'Premium型' ,
        't_RGX' : this.curData.name == 'RGM型' || this.curData.name == 'X型' || this.curData.name == 'X/RGX型' ,
        't_specom' :  this.curData.name == 'SPECOM系列'  ||  this.curData.name == 'Specom-K'  ||  this.curData.name == 'Specom-α'  ||  this.curData.name == 'Specom-β'
      }
    },
  },
  methods: {
    getData () {
      let id = this.id
      this.curData = this.pageData[ id ]

      this.$nextTick(() => {

        if( id == 'RA型' || id == 'R01型' ){
          document.getElementById("RA4").scrollIntoView({block: "center"});
        } else if( id == 'RN型' ){
          document.getElementById("RN7").scrollIntoView({block: "center"});
        } else if( id == 'RD型' ){
          document.getElementById("RD9").scrollIntoView({block: "center"});
        } else if( id == 'RE型' ){

        } else if( id == 'RGM型' ){   //RGM10
          document.getElementById("RGM10").scrollIntoView({block: "center"});
        } else if( id == 'RGS型' ) {
          document.getElementById("RGS8").scrollIntoView({block: "center"});
        } else if( id == 'Specom_GT'){
          document.getElementById("Specom_cont").scrollIntoView({block: "start"});
        } else if( id == 'Specom_α' ||  id == 'Specom_β' ){
          document.getElementById("Specom_cont").scrollIntoView({block: "center"});
        } else if( id == 'Specom_K'  ){
          document.getElementById("Specom_cont").scrollIntoView({block: "end"});
        }

        //Specom_cont
      })


    }
  } ,
  created(){
    this.id =  this.$route.params.id
    this.getData()
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id
      this.getData()

      // console.log( from )
    }
  }

};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear{
  position: relative
}
.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakeOil/img21.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px;
  box-sizing: border-box;
  font-size:30px
  color:#fff;
  text-align :center
}
.t_Premium{
  background: url('~@/assets/image/variousproducts/brakePadsDetail/Premium型/img1.png');
  width:256px;
}
.t_RGX {
  background: url('~@/assets/image/variousproducts/brakePadsDetail/RGM型/img1.png');
  width:196px;
  padding: 26px 31px 18px 42px
}
.t_specom {
  width: 204px ;
  padding: 21px 40px 20px 50px
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakeOil/img22.png');
  background-repeat: no-repeat;
  background-size: contain;
}



</style>
